// import React, { useState } from 'react';
// import {
//     Box,
//     Typography,
//     Button,
//     TextField,
//     InputAdornment,
//     Grid,
//     Card,
//     CardContent,
//     Accordion,
//     AccordionSummary,
//     AccordionDetails,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Chip,
//     CssBaseline
// } from '@mui/material';
// import { createTheme, ThemeProvider, styled } from '@mui/material/styles';

// // --- Icons (using MUI Icons) ---
// import PersonIcon from '@mui/icons-material/PersonOutline';
// import DownloadIcon from '@mui/icons-material/Download';
// import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
// import LocalOfferIcon from '@mui/icons-material/LocalOfferOutlined';
// import WarningAmberIcon from '@mui/icons-material/WarningAmberRounded'; // For PII
// import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
// import PlayArrowIcon from '@mui/icons-material/PlayArrow';
// import AccessTimeIcon from '@mui/icons-material/AccessTime';
// import PlaceIcon from '@mui/icons-material/PlaceOutlined';
// import BusinessIcon from '@mui/icons-material/BusinessOutlined';

// // --- Theme Configuration ---
// const theme = createTheme({
//     palette: {
//         primary: {
//             main: '#7e22ce', // Purple-700 equivalent
//             light: '#f3e8ff', // Purple-50 equivalent
//         },
//         background: {
//             default: '#ffffff', // Gray-50
//             paper: '#ffffff',
//         },
//         text: {
//             primary: '#1e293b', // Slate-800
//             secondary: '#64748b', // Slate-500
//         },
//     },
//     typography: {
//         fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
//         h6: { fontWeight: 700 },
//         subtitle1: { fontWeight: 600 },
//         subtitle2: { fontWeight: 600, fontSize: '0.75rem' },
//         body2: { fontSize: '0.875rem' },
//     },
//     components: {
//         MuiButton: {
//             styleOverrides: {
//                 root: {
//                     textTransform: 'none',
//                     borderRadius: 8,
//                     fontWeight: 500,
//                 },
//             },
//         },
//         MuiPaper: {
//             styleOverrides: {
//                 root: {
//                     boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.05)',
//                     border: '1px solid #e2e8f0',
//                 },
//                 elevation1: {
//                     boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
//                 }
//             },
//         },
//         MuiTableCell: {
//             styleOverrides: {
//                 head: {
//                     backgroundColor: '#f9fafb',
//                     color: '#64748b',
//                     fontWeight: 600,
//                     textTransform: 'uppercase',
//                     fontSize: '0.75rem',
//                     letterSpacing: '0.05em',
//                 },
//                 body: {
//                     fontSize: '0.875rem',
//                 }
//             }
//         }
//     },
// });


// const MainContent = styled(Box)(({ theme }) => ({
//     marginBottom: 80,
//     height: '100vh',
//     display: 'flex',
//     flexDirection: 'column',
//     backgroundColor: theme.palette.background.default,
// }));

// const StyledAccordion = styled(Accordion)(({ theme }) => ({
//     border: `1px solid ${theme.palette.divider}`,
//     borderRadius: theme.shape.borderRadius,
//     marginBottom: theme.spacing(2),
//     boxShadow: 'none',
//     '&:before': {
//         display: 'none',
//     },
//     '&.Mui-expanded': {
//         margin: theme.spacing(0, 0, 2, 0),
//     },
// }));

// // --- Helper Components ---

// const EntityTypeChip = ({ type }) => {
//     let color = 'default';
//     let icon = <LocalOfferIcon fontSize="small" />;
//     let styles = {};

//     switch (type) {
//         case 'Person':
//             color = 'primary'; // Blueish in concept
//             icon = <PersonIcon fontSize="small" />;
//             styles = { bgcolor: '#dbeafe', color: '#1d4ed8', borderColor: '#bfdbfe' }; // blue-100/700
//             break;
//         case 'Date/Time':
//             icon = <AccessTimeIcon fontSize="small" />;
//             styles = { bgcolor: '#ffedd5', color: '#c2410c', borderColor: '#fed7aa' }; // orange-100/700
//             break;
//         case 'Money':
//             icon = <AttachMoneyIcon fontSize="small" />;
//             styles = { bgcolor: '#dcfce7', color: '#15803d', borderColor: '#bbf7d0' }; // green-100/700
//             break;
//         case 'Location':
//             icon = <PlaceIcon fontSize="small" />;
//             styles = { bgcolor: '#fee2e2', color: '#b91c1c', borderColor: '#fecaca' }; // red-100/700
//             break;
//         case 'Organization':
//             icon = <BusinessIcon fontSize="small" />;
//             styles = { bgcolor: '#f3e8ff', color: '#7e22ce', borderColor: '#e9d5ff' }; // purple-100/700
//             break;
//         default:
//             styles = { bgcolor: '#f3f4f6', color: '#374151', borderColor: '#e5e7eb' };
//     }

//     return (
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//             <Box sx={{
//                 p: 0.5,
//                 borderRadius: 1,
//                 display: 'flex',
//                 ...styles
//             }}>
//                 {React.cloneElement(icon, { sx: { fontSize: 16 } })}
//             </Box>
//             <Typography variant="body2" fontWeight={500} color="text.secondary">
//                 {type}
//             </Typography>
//         </Box>
//     );
// };

// const EntityTable = ({ data }) => {
//     return (
//         <TableContainer>
//             <Table sx={{ minWidth: 650 }} aria-label="simple table">
//                 <TableHead>
//                     <TableRow>
//                         <TableCell>Type</TableCell>
//                         <TableCell>Extracted Value</TableCell>
//                         <TableCell sx={{ width: '35%' }}>Context</TableCell>
//                         <TableCell>Timestamp</TableCell>
//                         <TableCell align="right">Confidence</TableCell>
//                     </TableRow>
//                 </TableHead>
//                 <TableBody>
//                     {data.map((row) => (
//                         <TableRow
//                             key={row.id}
//                             sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&:hover': { bgcolor: 'action.hover' } }}
//                         >
//                             <TableCell component="th" scope="row">
//                                 <EntityTypeChip type={row.type} />
//                             </TableCell>
//                             <TableCell>
//                                 <Typography variant="body2" fontWeight={700}>
//                                     {row.value}
//                                 </Typography>
//                             </TableCell>
//                             <TableCell>
//                                 <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
//                                     "...{row.context}..."
//                                 </Typography>
//                             </TableCell>
//                             <TableCell>
//                                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary' }}>
//                                     <AccessTimeIcon sx={{ fontSize: 14 }} />
//                                     <Typography variant="body2">{row.timestamp}</Typography>
//                                 </Box>
//                             </TableCell>
//                             <TableCell align="right">
//                                 <Chip
//                                     label={`${row.confidence}%`}
//                                     size="small"
//                                     sx={{
//                                         bgcolor: row.confidence > 90 ? '#dcfce7' : '#fef9c3',
//                                         color: row.confidence > 90 ? '#166534' : '#854d0e',
//                                         fontWeight: 600,
//                                         fontSize: '0.75rem',
//                                         height: 20
//                                     }}
//                                 />
//                             </TableCell>
//                         </TableRow>
//                     ))}
//                 </TableBody>
//             </Table>
//         </TableContainer>
//     );
// };

// // --- Main Component ---

// export default function AudioAnalyticsMui(entitiesData) {
//     const [activeTab, setActiveTab] = useState('Entities');
//     const [expanded, setExpanded] = useState({
//         personal: true,
//         financial: true,
//         general: false
//     });

//     console.log(entitiesData, "entitiesData");

//     const handleAccordionChange = (panel) => (event, isExpanded) => {
//         setExpanded(prev => ({ ...prev, [panel]: isExpanded }));
//     };

//     function convertEntitiesToMockFormat(apiData) {
//         const result = {
//             personal: [],
//             financial: [],
//             general: []
//         };

//         if (!apiData?.entitiesData?.length) {
//             return result;
//         }

//         apiData.entitiesData.forEach(categoryItem => {
//             const { category, entities } = categoryItem;

//             if (!result[category] || !Array.isArray(entities)) return;

//             result[category] = entities.map(entity => ({
//                 id: entity.id,
//                 type: entity.type,
//                 value: entity.value,
//                 timestamp: entity.timestamp,
//                 confidence: Number(entity.confidence),
//                 context: entity.context
//             }));
//         });

//         return result;
//     };

//     const entities = convertEntitiesToMockFormat(entitiesData) || [];
//     console.log(entities , "entities");

//     function getEntitySummaryCards(entities) {
//     const personalCount = entities.personal?.length || 0;
//     const financialCount = entities.financial?.length || 0;
//     const generalCount = entities.general?.length || 0;

//     const allEntities = [
//         ...(entities.personal || []),
//         ...(entities.financial || []),
//         ...(entities.general || [])
//     ];

//     const totalEntities = allEntities.length;

//     const avgConfidence = totalEntities
//         ? Math.round(
//               allEntities.reduce(
//                   (sum, e) => sum + (Number(e.confidence) || 0),
//                   0
//               ) / totalEntities
//           )
//         : 0;

//     return [
//         {
//             icon: <LocalOfferIcon />,
//             color: 'primary',
//             label: 'Total Entities',
//             value: totalEntities.toString()
//         },
//         {
//             icon: <WarningAmberIcon />,
//             color: 'error',
//             label: 'PII Detected',
//             value: personalCount.toString()
//         },
//         {
//             icon: <AttachMoneyIcon />,
//             color: 'success',
//             label: 'Financial',
//             value: financialCount.toString()
//         },
//         {
//             icon: <PlayArrowIcon />,
//             color: 'info',
//             label: 'Avg Confidence',
//             value: `${avgConfidence}%`
//         }
//     ];
// }

//     const entitieMatrics = getEntitySummaryCards(entities) || []

//     // Mock Data
//     // const entities = {
//     //     personal: [
//     //         { id: 1, type: 'Person', value: 'Rajesh Kumar', timestamp: '00:15', confidence: 98, context: 'Hello, am I speaking with Mr. Rajesh Kumar' },
//     //         { id: 2, type: 'Phone', value: '+91 98765 43210', timestamp: '01:20', confidence: 95, context: 'confirm your registered mobile number ending in 43210' },
//     //     ],
//     //     financial: [
//     //         { id: 3, type: 'Money', value: '₹50,000', timestamp: '02:45', confidence: 92, context: 'regarding the personal loan application of fifty thousand rupees' },
//     //         { id: 4, type: 'Organization', value: 'HDFC Bank', timestamp: '03:10', confidence: 88, context: 'salary account is currently with HDFC Bank' },
//     //         { id: 5, type: 'Product', value: 'Platinum Credit Card', timestamp: '04:00', confidence: 96, context: 'eligible for our premium Platinum Credit Card' },
//     //     ],
//     //     general: [
//     //         { id: 6, type: 'Date/Time', value: 'Next Monday', timestamp: '05:30', confidence: 85, context: 'call you back by Next Monday around 10 AM' },
//     //         { id: 7, type: 'Location', value: 'Mumbai', timestamp: '00:45', confidence: 99, context: 'calling from our main branch in Mumbai' },
//     //     ]
//     // };

//     return (
//         <ThemeProvider theme={theme}>
//             {/* <CssBaseline /> */}
//             {/* Main Content Area */}
//             <MainContent component="main">
//                 {/* Scrollable Content */}
//                 <Box sx={{ flexGrow: 1 }}>

//                     <Box>
//                         {/* Tools Header */}
//                         <Box sx={{ mb: 4, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: { md: 'center' }, gap: 2 }}>
//                             <Box>
//                                 <Typography variant="h5" fontWeight={700} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                     Extracted Entities
//                                     {/* <Chip label="ID: #C-99821" size="small" variant="outlined" sx={{ color: 'text.secondary', bgcolor: 'grey.50' }} /> */}
//                                 </Typography>
//                                 <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
//                                     Key details extracted from the conversation audio..
//                                 </Typography>
//                             </Box>

//                             <Box sx={{ display: 'flex', gap: 2 }}>
//                                 {/* <TextField
//                                     size="small"
//                                     placeholder="Search entities..."
//                                     InputProps={{
//                                         startAdornment: (
//                                             <InputAdornment position="start">
//                                                 <SearchIcon fontSize="small" color="action" />
//                                             </InputAdornment>
//                                         ),
//                                     }}
//                                     sx={{ bgcolor: 'background.paper', width: 250 }}
//                                 /> */}
//                                 {/* <Button
//                                     variant="contained"
//                                     startIcon={<DownloadIcon />}
//                                     disableElevation
//                                 >
//                                     Export CSV
//                                 </Button> */}
//                             </Box>
//                         </Box>

//                         {/* KPI Cards */}
//                         <Grid container spacing={2} sx={{ mb: 4 }}>
//                             {entitieMatrics.map((stat, index) => (
//                                 <Grid item xs={12} sm={6} md={3} key={index}>
//                                     <Card elevation={0} sx={{ border: 1, borderColor: 'divider', borderRadius: 3 }}>
//                                         <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2, '&:last-child': { pb: 2 } }}>
//                                             <Box sx={{
//                                                 p: 1.5,
//                                                 borderRadius: 2,
//                                                 bgcolor: `${stat.color}.light`,
//                                                 color: `${stat.color}.main`,
//                                                 display: 'flex'
//                                             }}>
//                                                 {React.cloneElement(stat.icon, { fontSize: 'medium' })}
//                                             </Box>
//                                             <Box>
//                                                 <Typography variant="h5" fontWeight={700}>{stat.value}</Typography>
//                                                 <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase' }}>{stat.label}</Typography>
//                                             </Box>
//                                         </CardContent>
//                                     </Card>
//                                 </Grid>
//                             ))}
//                         </Grid>

//                         {/* Entities Accordions */}
//                         <Box>
//                             {/* Personal Info */}
//                             <StyledAccordion expanded={expanded.personal} onChange={handleAccordionChange('personal')}>
//                                 <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
//                                         <Typography variant="h6" color="error.main">Personal Information</Typography>
//                                         <Chip label={entities.personal.length} size="small" sx={{ height: 20, fontWeight: 700, bgcolor: 'grey.100' }} />
//                                     </Box>
//                                 </AccordionSummary>
//                                 <AccordionDetails sx={{ p: 0 }}>
//                                     <EntityTable data={entities.personal} />
//                                 </AccordionDetails>
//                             </StyledAccordion>

//                             {/* Financial Info */}
//                             <StyledAccordion expanded={expanded.financial} onChange={handleAccordionChange('financial')}>
//                                 <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
//                                         <Typography variant="h6" color="text.primary">Financial & Business</Typography>
//                                         <Chip label={entities.financial.length} size="small" sx={{ height: 20, fontWeight: 700, bgcolor: 'grey.100' }} />
//                                     </Box>
//                                 </AccordionSummary>
//                                 <AccordionDetails sx={{ p: 0 }}>
//                                     <EntityTable data={entities.financial} />
//                                 </AccordionDetails>
//                             </StyledAccordion>

//                             {/* General Info */}
//                             <StyledAccordion expanded={expanded.general} onChange={handleAccordionChange('general')}>
//                                 <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
//                                         <Typography variant="h6" color="text.primary">General Information</Typography>
//                                         <Chip label={entities.general.length} size="small" sx={{ height: 20, fontWeight: 700, bgcolor: 'grey.100' }} />
//                                     </Box>
//                                 </AccordionSummary>
//                                 <AccordionDetails sx={{ p: 0 }}>
//                                     <EntityTable data={entities.general} />
//                                 </AccordionDetails>
//                             </StyledAccordion>
//                         </Box>

//                     </Box>
//                 </Box>
//             </MainContent>

//         </ThemeProvider>
//     );
// }

import React, { useState } from 'react';
import {
    Box,
    Typography,
    Button,
    TextField,
    InputAdornment,
    Grid,
    Card,
    CardContent,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Chip,
    CssBaseline
} from '@mui/material';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';

// --- Icons (using MUI Icons) ---
import PersonIcon from '@mui/icons-material/PersonOutline';
import DownloadIcon from '@mui/icons-material/Download';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LocalOfferIcon from '@mui/icons-material/LocalOfferOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmberRounded';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import PlaceIcon from '@mui/icons-material/PlaceOutlined';
import BusinessIcon from '@mui/icons-material/BusinessOutlined';
import InboxIcon from '@mui/icons-material/InboxOutlined';
import { jwtDecode } from 'jwt-decode';

// --- Theme Configuration ---
const theme = createTheme({
    palette: {
        primary: {
            main: '#7e22ce',
            light: '#f3e8ff',
        },
        background: {
            default: '#ffffff',
            paper: '#ffffff',
        },
        text: {
            primary: '#1e293b',
            secondary: '#64748b',
        },
    },
    typography: {
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        h6: { fontWeight: 700 },
        subtitle1: { fontWeight: 600 },
        subtitle2: { fontWeight: 600, fontSize: '0.75rem' },
        body2: { fontSize: '0.875rem' },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: 8,
                    fontWeight: 500,
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.05)',
                    border: '1px solid #e2e8f0',
                },
                elevation1: {
                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                }
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    backgroundColor: '#f9fafb',
                    color: '#64748b',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    fontSize: '0.75rem',
                    letterSpacing: '0.05em',
                },
                body: {
                    fontSize: '0.875rem',
                }
            }
        }
    },
});

const MainContent = styled(Box)(({ theme }) => ({
    marginBottom: 80,
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.default,
}));

const StyledAccordion = styled(Accordion)(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    marginBottom: theme.spacing(2),
    boxShadow: 'none',
    '&:before': {
        display: 'none',
    },
    '&.Mui-expanded': {
        margin: theme.spacing(0, 0, 2, 0),
    },
}));

// --- Helper Components ---

const EntityTypeChip = ({ type }) => {
    let color = 'default';
    let icon = <LocalOfferIcon fontSize="small" />;
    let styles = {};


    // Map entity types to colors/icons
    const typeMapping = {
        'Person': { icon: <PersonIcon fontSize="small" />, styles: { bgcolor: '#dbeafe', color: '#1d4ed8', borderColor: '#bfdbfe' } },
        'Date/Time': { icon: <AccessTimeIcon fontSize="small" />, styles: { bgcolor: '#ffedd5', color: '#c2410c', borderColor: '#fed7aa' } },
        'Money': { icon: <AttachMoneyIcon fontSize="small" />, styles: { bgcolor: '#dcfce7', color: '#15803d', borderColor: '#bbf7d0' } },
        'Location': { icon: <PlaceIcon fontSize="small" />, styles: { bgcolor: '#fee2e2', color: '#b91c1c', borderColor: '#fecaca' } },
        'Organization': { icon: <BusinessIcon fontSize="small" />, styles: { bgcolor: '#f3e8ff', color: '#7e22ce', borderColor: '#e9d5ff' } },
    };

    const matched = typeMapping[type] || { icon, styles: { bgcolor: '#f3f4f6', color: '#374151', borderColor: '#e5e7eb' } };

    return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Box sx={{
                p: 0.5,
                borderRadius: 1,
                display: 'flex',
                ...matched.styles
            }}>
                {React.cloneElement(matched.icon, { sx: { fontSize: 16 } })}
            </Box>
            <Typography variant="body2" fontWeight={500} color="text.secondary">
                {type}
            </Typography>
        </Box>
    );
};

const EntityTable = ({ data }) => {
    const token = localStorage.getItem("token");
    const decodedToken = token ? jwtDecode(token) : "";
    const hasData = data && data.length > 0;
    console.log(data, "data");


    return (
        <TableContainer>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Type</TableCell>
                        <TableCell>Extracted Value</TableCell>
                        {/* {decodedToken.companyId === "67e560a6ae2e0d3f96b5eb09" && (
                            <>
                                <TableCell sx={{ whiteSpace: 'nowrap' }}>CRM Data</TableCell>
                                <TableCell>Match</TableCell>
                            </>
                        )} */}
                        <TableCell sx={{ width: '35%' }}>Context</TableCell>
                        {/* <TableCell>Timestamp</TableCell> */}
                        <TableCell align="right">Confidence</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {hasData ? (
                        data.map((row) => (
                            <TableRow
                                key={row.id}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&:hover': { bgcolor: 'action.hover' } }}
                            >
                                <TableCell component="th" scope="row">
                                    <EntityTypeChip type={row.type} />
                                </TableCell>
                                <TableCell>
                                    <Typography variant="body2" fontWeight={700}>
                                        {row.value}
                                    </Typography>
                                </TableCell>
                                {/* {decodedToken.companyId === "67e560a6ae2e0d3f96b5eb09" && (
                                    <>
                                        <TableCell>
                                            <Typography variant="body2" fontWeight={700}>
                                                {row.CRMData}
                                            </Typography>
                                        </TableCell>

                                        <TableCell>
                                            <Chip
                                                label={
                                                    row.match === true
                                                        ? 'Matched'
                                                        : row.match === false
                                                            ? 'Not Matched'
                                                            : 'N/A'
                                                }
                                                size="small"
                                                sx={{
                                                    fontWeight: 600,
                                                    height: 22,
                                                    bgcolor:
                                                        row.match === true
                                                            ? '#dcfce7'
                                                            : row.match === false
                                                                ? '#fee2e2'
                                                                : '#f3f4f6',
                                                    color:
                                                        row.match === true
                                                            ? '#166534'
                                                            : row.match === false
                                                                ? '#991b1b'
                                                                : '#374151',
                                                }}
                                            />
                                        </TableCell>
                                    </>
                                )} */}



                                <TableCell>
                                    <Typography variant="body2" color="text.secondary" sx={{ fontStyle: 'italic', display: '-webkit-box', WebkitLineClamp: 1, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                                        {row.context ? `"...${row.context}..."` : 'N/A'}
                                    </Typography>
                                </TableCell>
                                {/* <TableCell>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, color: 'text.secondary' }}>
                                        <AccessTimeIcon sx={{ fontSize: 14 }} />
                                        <Typography variant="body2">{row.timestamp}</Typography>
                                    </Box>
                                </TableCell> */}
                                <TableCell align="right">
                                    <Chip
                                        label={`${row.confidence}%`}
                                        size="small"
                                        sx={{
                                            bgcolor: row.confidence > 90 ? '#dcfce7' : '#fef9c3',
                                            color: row.confidence > 90 ? '#166534' : '#854d0e',
                                            fontWeight: 600,
                                            fontSize: '0.75rem',
                                            height: 20
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                        ))
                    ) : (
                        <TableRow>
                            <TableCell colSpan={5} sx={{ border: 0 }}>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        py: 6,
                                        px: 2
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: 'inline-flex',
                                            p: 2,
                                            borderRadius: '50%',
                                            bgcolor: 'grey.100',
                                            color: 'text.secondary',
                                            mb: 2
                                        }}
                                    >
                                        <InboxIcon sx={{ fontSize: 40 }} />
                                    </Box>
                                    <Typography variant="subtitle1" fontWeight={600} color="text.primary" gutterBottom>
                                        No Entities Detected
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ maxWidth: 350 }}>
                                        No entities were extracted from the conversation audio. This could mean the conversation didn't contain extractable data points
                                    </Typography>
                                </Box>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

// --- Main Component ---

export default function AudioAnalyticsMui({ entitiesData }) {
    // Convert API data to organized format with dynamic categories

    function normalizeMatch(match) {
        if (match === true || match === 'true') return true;
        if (match === false || match === 'false') return false;
        return null;
    }


    function convertEntitiesToDynamicFormat(apiData) {
        if (!apiData?.length) return {};

        const result = {};

        apiData.forEach(categoryItem => {
            const { category, entities } = categoryItem;

            if (!category || !Array.isArray(entities)) return;

            result[category] = entities.map(entity => ({
                id: entity.id,
                type: entity.type,
                value: entity.value,
                CRMData: entity.CRMData ?? 'N/A',
                match: normalizeMatch(entity.match),
                timestamp: entity.timestamp,
                confidence: Number(entity.confidence),
                context: entity.context
            }));
        });

        return result;
    }

    const entities = convertEntitiesToDynamicFormat(entitiesData);
    const hasAnyEntities = Object.keys(entities).length > 0;

    // Initialize expanded state dynamically based on categories
    const [expanded, setExpanded] = useState(() => {
        const initialState = {};
        Object.keys(entities).forEach((key, index) => {
            initialState[key] = index < 2; // Expand first 2 categories by default
        });
        return initialState;
    });

    const handleAccordionChange = (panel) => (event, isExpanded) => {
        setExpanded(prev => ({ ...prev, [panel]: isExpanded }));
    };

    // Generate summary cards dynamically
    function getEntitySummaryCards(entities) {
        const allEntities = Object.values(entities).flat();
        const totalEntities = allEntities.length;

        const avgConfidence = totalEntities
            ? Math.round(
                allEntities.reduce(
                    (sum, e) => sum + (Number(e.confidence) || 0),
                    0
                ) / totalEntities
            )
            : 0;

        const categoryCount = Object.keys(entities).length;

        return [
            {
                icon: <LocalOfferIcon />,
                color: 'primary',
                label: 'Total Entities',
                value: totalEntities.toString()
            },
            {
                icon: <WarningAmberIcon />,
                color: 'error',
                label: 'Categories',
                value: categoryCount.toString()
            },
            {
                icon: <AttachMoneyIcon />,
                color: 'success',
                label: 'Data Points',
                value: totalEntities.toString()
            },
            {
                icon: <PlayArrowIcon />,
                color: 'info',
                label: 'Avg Confidence',
                value: `${avgConfidence}%`
            }
        ];
    }

    const entitiesMetrics = getEntitySummaryCards(entities);

    // Helper to format category names for display
    const formatCategoryName = (category) => {
        return category
            .split('_')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };

    return (
        <ThemeProvider theme={theme}>
            <MainContent component="main">
                <Box sx={{ flexGrow: 1 }}>
                    <Box>
                        {/* Header */}
                        <Box sx={{ mb: 4, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, justifyContent: 'space-between', alignItems: { md: 'center' }, gap: 2 }}>
                            <Box>
                                <Typography variant="h5" fontWeight={700} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    Extracted Entities
                                </Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                                    Key details extracted from the conversation audio
                                </Typography>
                            </Box>
                        </Box>

                        {/* KPI Cards */}
                        <Grid container spacing={2} sx={{ mb: 4 }}>
                            {entitiesMetrics.map((stat, index) => (
                                <Grid item xs={12} sm={6} md={3} key={index}>
                                    <Card elevation={0} sx={{ border: 1, borderColor: 'divider', borderRadius: 3 }}>
                                        <CardContent sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2, '&:last-child': { pb: 2 } }}>
                                            <Box sx={{
                                                p: 1.5,
                                                borderRadius: 2,
                                                bgcolor: `${stat.color}.light`,
                                                color: `${stat.color}.main`,
                                                display: 'flex'
                                            }}>
                                                {React.cloneElement(stat.icon, { fontSize: 'medium' })}
                                            </Box>
                                            <Box>
                                                <Typography variant="h5" fontWeight={700}>{stat.value}</Typography>
                                                <Typography variant="caption" fontWeight={600} color="text.secondary" sx={{ textTransform: 'uppercase' }}>{stat.label}</Typography>
                                            </Box>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>

                        {/* Dynamic Entities Accordions */}
                        <Box>
                            {hasAnyEntities ? (
                                Object.entries(entities).map(([categoryKey, categoryEntities]) => (
                                    <StyledAccordion
                                        key={categoryKey}
                                        expanded={expanded[categoryKey]}
                                        onChange={handleAccordionChange(categoryKey)}
                                    >
                                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                                                <Typography variant="h6" color="text.primary">
                                                    {formatCategoryName(categoryKey)}
                                                </Typography>
                                                <Chip
                                                    label={categoryEntities.length}
                                                    size="small"
                                                    sx={{ height: 20, fontWeight: 700, bgcolor: 'grey.100' }}
                                                />
                                            </Box>
                                        </AccordionSummary>
                                        <AccordionDetails sx={{ p: 0 }}>
                                            <EntityTable data={categoryEntities} />
                                        </AccordionDetails>
                                    </StyledAccordion>
                                ))
                            ) : (
                                <StyledAccordion expanded={true}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                                            <Typography variant="h6" color="text.primary">
                                                Entities
                                            </Typography>
                                            <Chip
                                                label={0}
                                                size="small"
                                                sx={{ height: 20, fontWeight: 700, bgcolor: 'grey.100' }}
                                            />
                                        </Box>
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ p: 0 }}>
                                        <EntityTable data={[]} />
                                    </AccordionDetails>
                                </StyledAccordion>
                            )}
                        </Box>
                    </Box>
                </Box>
            </MainContent>
        </ThemeProvider>
    );
}